{
  "currency": {
    "name": "euro",
    "name_plural": "euro",
    "symbol": "€",
    "code": "EUR"
  },
  "date": {
    "format": "d.m.yyyy",
    "format_long": "d.m.yyyy HH:mm:ss",
    "format_short": "d.m.yyyy",
    "format_time": "HH:mm:ss"
  },
  "number": {
    "decimal_separator": ",",
    "thousand_separator": ".",
    "decimal_places": 2
  },
  "property": {
    "building_types": ["apartment", "detached", "duplex", "row", "farmhouse", "other"],
    "room_types": ["bedroom", "bathroom"],
    "min_year": 1900,
    "min_size": 5,
    "max_size": 1000,
    "min_rooms": 1,
    "max_rooms": 20,
    "min_price": 5000,
    "max_price": 15000000
  },
  "users": {
    "roles": ["buyer", "realtor", "seller"]
  },
  "realtor": {
    "realtor_role": "realtor",
    "revenue_share": 0.2
  }
}
